// Generous EIP-1559 fee cap from live network data. PulseChain's base fee swings hard
// (hundreds of thousands of gwei within minutes); a fixed wallet estimate often gets
// overtaken and the tx is stranded. A 2x cap gives headroom — you still only pay the
// actual base fee + tip. Shared by the vault wizard and the trapped-JDAI recovery tool.
export const txOverrides = async (provider) => {
  try {
    const fee = await provider.getFeeData();
    if (fee.maxFeePerGas && fee.maxPriorityFeePerGas) {
      return { maxFeePerGas: fee.maxFeePerGas * 2n, maxPriorityFeePerGas: fee.maxPriorityFeePerGas };
    }
    if (fee.gasPrice) return { gasPrice: fee.gasPrice * 2n };
  } catch (e) {
    console.warn('Could not fetch fee data; using wallet default gas', e);
  }
  return {};
};
